/* =====================================================================
   blend kyoto - renewal : animations
   - 初回ローディング (家紋フェード)
   - KV のズーム/ロゴ浮かび開始トリガー (body.bk-loaded)
   - スクロール フェードイン (フェードのみ / IntersectionObserver)
   ===================================================================== */
(function () {
  window.__bkAnim = true; // head のフェイルセーフへ「JSは動いた」と通知
  window.__bkHeaderShownAt = 0; // ヘッダー表示アニメが終わった時刻 (philosophy のリンク表示基点)
  var doc = document;

  function startPage() {
    if (doc.body) doc.body.classList.add('bk-loaded'); // KVアニメ開始
  }

  /* KV のアクティブ画像(なければ動画)が「描画できる状態」になるまで待つ。
     これを待たずにローダーを引っ込めると、フェードインが空振りして
     画像が出てこないことがあるため。対象が無い下層ページ等は即 cb。 */
  function whenHeroReady(cb) {
    var media = doc.querySelector('.bk-hero__media');
    if (!media) {
      cb();
      return;
    }

    var fired = false;
    var fire = function () {
      if (fired) return;
      fired = true;
      cb();
    };

    var video = media.querySelector('video');
    if (video) {
      if (video.readyState >= 2) fire();
      else {
        video.addEventListener('loadeddata', fire, { once: true });
        video.addEventListener('error', fire, { once: true });
      }
      return;
    }

    var img =
      media.querySelector('.bk-hero__slide.is-active img') ||
      media.querySelector('img');
    if (!img) {
      fire(); // 画像なし(プレースホルダ等)
      return;
    }

    var afterLoad = function () {
      // デコードまで終わらせてから(初回ペイントの空振り防止)
      if (img.decode) img.decode().then(fire, fire);
      else fire();
    };

    if (img.complete && img.naturalWidth > 0) afterLoad();
    else {
      img.addEventListener('load', afterLoad, { once: true });
      img.addEventListener('error', fire, { once: true });
    }
  }

  /* ---- 初回ローディング ---- */
  var loader = doc.getElementById('bk-loader');
  if (loader) {
    var shown = false;
    try {
      shown = sessionStorage.getItem('bkLoaderShown') === '1';
    } catch (e) {}

    if (shown) {
      if (loader.parentNode) loader.parentNode.removeChild(loader);
      startPage();
      window.__bkHeaderShownAt = Date.now(); // 2回目以降はヘッダー即表示
    } else {
      // 出現ワイプ(0.55s)→文字/ロゴfade(0.5+0.6=1.1s)。この一連が途中で
      // 切れないよう、組み上がった画面を見せてから閉じる最低表示時間を確保。
      var MIN_MS = 1700; // 最低表示
      var HEADER_MS = 1500; // ヘッダー再表示まで(is-done基点。チラ見え防止)
      var REMOVE_MS = 1200; // loader DOM 除去まで(is-done基点)
      var start = Date.now();
      var done = false;
      // ローディング中はヘッダーを隠す(初回のみ。退場時のチラ見え防止)
      if (doc.body) doc.body.classList.add('bk-intro');
      var hide = function () {
        if (done) return;
        done = true;
        loader.classList.add('is-done');
        try {
          sessionStorage.setItem('bkLoaderShown', '1');
        } catch (e) {}
        startPage();
        // 退場(ワイプ0.6s + 白フェード 0.55+0.5=1.05s)が終わってから除去
        setTimeout(function () {
          if (loader.parentNode) loader.parentNode.removeChild(loader);
        }, REMOVE_MS);
        // 退場が完全に終わってからヘッダーを再表示
        setTimeout(function () {
          if (doc.body) doc.body.classList.remove('bk-intro');
          window.__bkHeaderShownAt = Date.now();
        }, HEADER_MS);
      };
      // KV画像が描画可能になってから、最低表示時間を満たして閉じる
      whenHeroReady(function () {
        setTimeout(hide, Math.max(0, MIN_MS - (Date.now() - start)));
      });
      setTimeout(hide, 8000); // 安全弁(画像が極端に遅くても必ず閉じる)
    }
  } else {
    startPage();
    window.__bkHeaderShownAt = Date.now();
  }

  /* ---- ページ エントリー フェードイン ---- */
  // 遷移後の新ページで、覆っていた背景面が抜けたタイミングに合わせて中身を
  // フェードインさせる。ファーストビュー要素は IntersectionObserver だと初回
  // 描画前に .bk-in が付いてフェードが見えないため、DOM解析完了後にディレイ+
  // double-rAF を挟んで明示付与する(起点の詳細は setupEntry を参照)。
  //   ・商品ページ : 各セクションをカスケードでフェード(productEntrySelector)。
  //   ・それ以外    : #MainContent をまとめて軽くフェード(汎用)。
  //   ・トップ(template-index): ローダー + スクロールIO演出を持つため対象外。
  // ※head のフェイルセーフは __bkAnim=true で無効化されるので、隠した要素は
  //   JS が必ず表示する責任を持つ(下の保険タイマーで二重に担保)。
  // ヘッダー(.section-header)は含めない。遷移フェードに載せると「一度消えて再フェード」
  // するチラつきが出るため常時表示のままにする(表示制御は bk-intro / is-over-hero)。
  var productEntrySelector =
    '.product__media-wrapper, .product__info-container, ' +
    '.bk-product__gallery-col, .bk-product__specs, .bk-product__buy';
  var PRODUCT_ENTRY_DELAY_MS = 1700;
  // about / stores は縦書き和文フォント(TypeSquare/Typekit)の読み込みが挟まるため、直アクセス/
  // リロードで即 #MainContent に .bk-in を付けるとペイントホールド中にフェードが完了して
  // 「パッと現れる」。商品ページ同様に固定ディレイで初回描画後に開始を遅らせる(調整可)。
  var ABOUT_ENTRY_DELAY_MS = 1700;
  var STORES_ENTRY_DELAY_MS = 1700;
  var SUPPORT_ENTRY_DELAY_MS = 1700;
  var CONTACT_ENTRY_DELAY_MS = 1700;
  var CART_ENTRY_DELAY_MS = 1700;
  // 商品一覧(collection)はカードを左上→右下にカスケードでフェードさせる。1枚あたりの
  // ずらし量(秒)。DOM順=グリッドの並び順=視覚上の左上→右下。
  var COLLECTION_CARD_STAGGER_S = 0.1;
  // カスケード開始も初回ペイント後に遅らせないと、opacity:0 が描画される前に .bk-in が
  // 付いてフェードが走らず「パッと現れる」(about/stores と同じ)。開始まで固定ディレイ。
  var COLLECTION_ENTRY_DELAY_MS = 1500;
  var ENTRY_REVEAL_AT_KEY = 'bkProductEntryRevealAt';
  var entryRevealed = false;
  var entryScheduled = false;

  function isProductPage() {
    return doc.body && doc.body.className.indexOf('template-product') !== -1;
  }
  function isIndexPage() {
    return doc.body && doc.body.className.indexOf('template-index') !== -1;
  }
  function isAboutPage() {
    return !!doc.querySelector('.bk-about__philosophy');
  }
  function isStoresPage() {
    return !!doc.querySelector('.bk-stores-page');
  }
  function isSupportPage() {
    return !!doc.querySelector('.bk-support');
  }
  function isContactPage() {
    return !!doc.querySelector('.bk-contact');
  }
  function isCartPage() {
    return doc.body && doc.body.className.indexOf('template-cart') !== -1;
  }
  function isCollectionPage() {
    return doc.body && doc.body.className.indexOf('template-collection') !== -1;
  }
  // 和文Webフォント依存で初回ペイントが重く、固定ディレイで初回描画後に開始すべきページ。
  // 遷移マスクの revealAt は使わず(過ぎていると即 is-in→ペイントホールド中に完了して pop するため)
  // 常に固定ディレイに統一する。値は fixedEntryDelay() を参照。
  // 商品詳細も対象: 一覧などから遷移すると load が revealAt を追い越して pop するため。
  function isHeavyEntryPage() {
    return (
      isAboutPage() ||
      isStoresPage() ||
      isSupportPage() ||
      isContactPage() ||
      isCartPage() ||
      isCollectionPage() ||
      isProductPage()
    );
  }
  function fixedEntryDelay() {
    if (isAboutPage()) return ABOUT_ENTRY_DELAY_MS;
    if (isStoresPage()) return STORES_ENTRY_DELAY_MS;
    if (isSupportPage()) return SUPPORT_ENTRY_DELAY_MS;
    if (isContactPage()) return CONTACT_ENTRY_DELAY_MS;
    if (isCartPage()) return CART_ENTRY_DELAY_MS;
    if (isCollectionPage()) return COLLECTION_ENTRY_DELAY_MS;
    return PRODUCT_ENTRY_DELAY_MS;
  }
  // 汎用フェード(#MainContent)対象 = 商品ページでもトップでもないページ
  function genericEntryEnabled() {
    return (
      !isProductPage() && !isIndexPage() && !!doc.getElementById('MainContent')
    );
  }
  function entryEnabled() {
    return isProductPage() || genericEntryEnabled();
  }

  function entryTargets() {
    if (isProductPage()) return doc.querySelectorAll(productEntrySelector);
    var main = doc.getElementById('MainContent');
    return main ? [main] : [];
  }

  // 商品一覧のカードを左上→右下にカスケードで表示する。
  // 「カードは .bk-in を持つ時だけ見える(付与はJSの責任)」を不変条件にすることで、
  // フィルタ/並べ替えの Ajax 差し替え後も re-reveal で必ず表示できる(隠れ残り防止)。
  //   ・initial=true : 初回ロード。ずらし付きでカスケード。
  //   ・initial=false: Ajax 後。即時表示(絞り込みのたびにパラパラさせない)。
  function revealCollectionCards(scope, initial) {
    scope = scope || doc;
    var cards = scope.querySelectorAll('.bk-collection__grid .bk-card');
    for (var i = 0; i < cards.length; i++) {
      cards[i].style.transitionDelay = initial
        ? (i * COLLECTION_CARD_STAGGER_S).toFixed(2) + 's'
        : '0s';
      cards[i].classList.add('bk-in');
    }
  }
  // Ajax 差し替え後に bk-collection.liquid から呼ぶ(新カードを即表示)。
  window.bkRevealCollectionCards = function (scope) {
    revealCollectionCards(scope || doc, false);
  };

  function revealEntry() {
    if (entryRevealed) return;
    entryRevealed = true;
    if (isCollectionPage()) {
      revealCollectionCards(doc, true);
      return;
    }
    var els = entryTargets();
    for (var i = 0; i < els.length; i++) els[i].classList.add('bk-in');
    if (isProductPage()) doc.body.classList.add('bk-product-entry-in');
  }

  function entryDelay() {
    // about / stores は和文Webフォント(TypeSquare/Typekit)依存でロードが重く、遷移マスクの
    // revealAt を過ぎてから初回ペイントが来ることがある。revealAt を使うと「もう過ぎている
    // →即 is-in →ペイントホールド中に完了」でフェードが空振りするため、revealAt は使わず
    // 常に固定ディレイで初回ペイント後に開始する(遷移/直アクセス/リロード共通)。
    if (isHeavyEntryPage()) {
      try { sessionStorage.removeItem(ENTRY_REVEAL_AT_KEY); } catch (e) {}
      return fixedEntryDelay();
    }
    // ここに来るのは汎用ページ(#MainContent 一括フェード)のみ。
    // 遷移経由: 旧ページが保存した revealAt まで待つ(背景面が抜けた後に開始)。
    try {
      var revealAt = Number(sessionStorage.getItem(ENTRY_REVEAL_AT_KEY));
      sessionStorage.removeItem(ENTRY_REVEAL_AT_KEY);
      if (revealAt > 0) return Math.max(0, revealAt - Date.now());
    } catch (e) {}
    // 直アクセス/リロード: 即時(初回ペイントは double-rAF で待つ)。
    return 0;
  }

  function startEntry() {
    if (entryRevealed || !entryEnabled()) return;
    if (doc.visibilityState === 'hidden') {
      doc.addEventListener(
        'visibilitychange',
        function onVisible() {
          if (doc.visibilityState !== 'hidden') {
            doc.removeEventListener('visibilitychange', onVisible);
            startEntry();
          }
        },
        false
      );
      return;
    }

    if (entryScheduled) return;
    entryScheduled = true;

    setTimeout(function () {
      requestAnimationFrame(function () {
        requestAnimationFrame(revealEntry);
      });
    }, entryDelay());
  }

  function setupEntry() {
    if (!entryEnabled()) return;
    // 開始タイマーの起点は「DOM解析完了(このdeferスクリプトの実行時点)」。
    // 以前は pageshow(= load 後 = 全画像の読み込み後)起点だったため、画像が重い
    // ページでは固定ディレイ(1500〜1700ms)の開始自体が数秒遅れていた。
    // 固定ディレイは「初回ペイント後に開始する」ための猶予なので、起点は DOM 完了で
    // 十分(ペイントホールドは最大でも数百ms。加えて revealEntry 前の double-rAF が
    // 実フレーム描画を保証する)。ディレイ値・フェードの見た目は不変。
    startEntry();
    // bfcache 復帰(pageshow persisted)の取りこぼし防止
    window.addEventListener('pageshow', startEntry, { once: true });
    // 保険1: pageshow が来ない場合でもスケジュールする
    setTimeout(function () {
      if (!entryRevealed && doc.readyState === 'complete') startEntry();
    }, 2500);
    // 保険2: 何らかの理由で表示されなければ強制的に表示する(隠れFOUC防止)
    setTimeout(function () {
      if (!entryRevealed) revealEntry();
    }, 6000);
  }

  setupEntry();

  /* ---- スクロール フェードイン ---- */
  var selector =
    '.bk-new-arrival, .bk-popular, .bk-start-here, .bk-stores, .bk-footer';

  function revealAll() {
    var els = doc.querySelectorAll(selector);
    for (var i = 0; i < els.length; i++) els[i].classList.add('bk-in');
  }

  function setupReveal() {
    try {
      var targets = [].slice.call(doc.querySelectorAll(selector));
      if (!('IntersectionObserver' in window) || !targets.length) {
        revealAll();
      } else {
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.classList.add('bk-in');
                io.unobserve(entry.target);
              }
            });
          },
          // 要素の上端がビューポート下端から少し入ったらフェードイン。
          // threshold(面積比)だとSPの店舗紹介のようにビューポートより高い要素は
          // 40%が同時に画面内へ入らず発火しないため、rootMargin(下端を25%詰める)で判定する。
          { threshold: 0, rootMargin: '0px 0px -25% 0px' }
        );
        targets.forEach(function (el) {
          io.observe(el);
        });
      }
    } catch (err) {
      revealAll();
    }
  }

  /* ---- philosophy (KV直後) の順次フェードイン ----
     リンク(左下・sticky) → 見出し → 本文 の順。
     ・リンク: セクションが視界に入った時。ただし「ヘッダー表示の 0.5s 後」までは待つ。
     ・見出し/本文: さらにスクロールして十分に入った時 (本文は CSS の transition-delay で見出しの後)。 */
  function whenHeaderShown(cb) {
    var GAP = 500;
    (function check() {
      var t = window.__bkHeaderShownAt;
      if (t) setTimeout(cb, Math.max(0, t + GAP - Date.now()));
      else setTimeout(check, 80);
    })();
  }

  function setupPhilosophy() {
    var sec = doc.querySelector('.bk-philosophy');
    if (!sec) return;

    var revealLink = function () {
      whenHeaderShown(function () {
        sec.classList.add('bk-reveal-link');
      });
    };
    var revealContent = function () {
      sec.classList.add('bk-reveal-heading');
    };

    if (!('IntersectionObserver' in window)) {
      revealContent();
      revealLink();
      return;
    }

    // 見出し/本文: コンテンツが画面中央に来た時に「その場で」フェードイン (先に出す)。
    // 中央に達するまでは opacity:0 のままなので、下から上がってくるようには見えず、
    // 中央でパッと現れる。rootMargin で root を中央の0px帯に潰して判定する。
    var centerTarget = sec.querySelector('.bk-philosophy__concept') || sec;
    var ioContent = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            ioContent.unobserve(entry.target);
            revealContent();
          }
        });
      },
      { threshold: 0, rootMargin: '-40% 0px -40% 0px' }
    );
    ioContent.observe(centerTarget);

    // リンク: 本文が出たあと、さらにスクロールして track 下寄りの基点が
    // 画面中央付近まで来たら出す (= 中央文章 → その後 左下リンク → sticky解除 の順)。
    var linkTrigger = sec.querySelector('.bk-philosophy__link-trigger') || sec;
    var ioLink = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            ioLink.unobserve(entry.target);
            revealLink();
          }
        });
      },
      { threshold: 0, rootMargin: '-50% 0px -30% 0px' }
    );
    ioLink.observe(linkTrigger);
  }

  /* ---- about ページ フェードイン ----
     ・philosophy : 見出し+本文をフェード (ファーストビュー → 入場で出る)
     ・story      : 写真が先に出て sticky → 少しスクロールで見出し+本文がフェード
       - is-photo-in : story が視界に入り始めたら写真を出す
       - is-text-in  : さらにスクロールして中央寄りに来たらテキスト(見出し→本文)
     ・link       : 視界に入ったらフェード
     ※ html.bk-anim で隠しているので、JSが必ず表示する責任を持つ(失敗時は catch で全表示)。 */
  function setupAbout() {
    var root = doc.querySelector('.bk-about');
    var company = doc.querySelector('.bk-company');
    if (!root && !company) return;

    var supported = 'IntersectionObserver' in window;

    var revealAllAbout = function () {
      var sels = ['.bk-about__philosophy', '.bk-about__story', '.bk-about__link', '.bk-company'];
      for (var s = 0; s < sels.length; s++) {
        var nodes = doc.querySelectorAll(sels[s]);
        for (var n = 0; n < nodes.length; n++) {
          nodes[n].classList.add('is-in', 'is-photo-in', 'is-text-in', 'bk-in');
        }
      }
    };

    try {
      var observe = function (el, cls, margin) {
        if (!el) return;
        if (!supported) {
          el.classList.add(cls);
          return;
        }
        var io = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                io.unobserve(entry.target);
                entry.target.classList.add(cls);
              }
            });
          },
          { threshold: 0, rootMargin: margin }
        );
        io.observe(el);
      };

      if (root) {
        // philosophy(ファーストビュー)は個別フェードを持たず、#MainContent 全体の
        // 汎用エントリーフェード(revealEntry)でページタイトルごと一括で出す。
        var stories = root.querySelectorAll('.bk-about__story');
        for (var i = 0; i < stories.length; i++) {
          // 写真: story の上端が入り始めたら早めに出す
          observe(stories[i], 'is-photo-in', '0px 0px -12% 0px');
          // テキスト: 写真が sticky で止まったあと、中央寄りに来たら出す
          observe(stories[i], 'is-text-in', '-25% 0px -25% 0px');
        }

      }

      // 商品一覧へ リンク (banners セクション先頭に移動したため document 全体から探す)
      observe(doc.querySelector('.bk-about__link'), 'is-in', '0px 0px -10% 0px');

      // 会社概要: 見出し → リスト の順にフェード (セクション全体に bk-in)
      observe(company, 'bk-in', '0px 0px -10% 0px');
    } catch (err) {
      revealAllAbout();
    }
  }

  // ファーストビューの要素は観測直後に即交差して発火するが、それが初回ペイント前だと
  // opacity:0 が一度も描画されず fade が走らない(=パッと表示される)。
  // double rAF で初回ペイント後にセットアップし、opacity:0 を1フレーム描画させてから
  // bk-in を付ける(=必ずフェードが見える)。
  requestAnimationFrame(function () {
    requestAnimationFrame(function () {
      setupReveal();
      setupPhilosophy();
      setupAbout();
    });
  });
})();
